<template>
  <div id="app">
    <OrderForm />
  </div>
</template>

<script>
import OrderForm from './components/OrderForm.vue'

export default {
  name: 'app',
  components: {
    OrderForm
  }
}
</script>

<style>
#app {

}
</style>
